/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/users-authz-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/users-authz-api-client";
import type { UsersAuthzAPIAdminPermissionsWriteResetUserPermissionsMutationResponse, UsersAuthzAPIAdminPermissionsWriteResetUserPermissionsPathParams } from "../models/UsersAuthzAPIAdminPermissionsWriteResetUserPermissions";

function getUsersAuthzAPIAdminPermissionsWriteResetUserPermissionsUrl(userId: UsersAuthzAPIAdminPermissionsWriteResetUserPermissionsPathParams["userId"]) {
  const res = { method: 'POST', url: `/admin/user/${userId}/permissions/reset` as const }  
  return res
}

/**
 * @summary Reset all permissions for a user
 * {@link /admin/user/:userId/permissions/reset}
 */
export async function usersAuthzAPIAdminPermissionsWriteResetUserPermissions(userId: UsersAuthzAPIAdminPermissionsWriteResetUserPermissionsPathParams["userId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<UsersAuthzAPIAdminPermissionsWriteResetUserPermissionsMutationResponse, ResponseErrorConfig<Error>, unknown>({ method : "POST", url : getUsersAuthzAPIAdminPermissionsWriteResetUserPermissionsUrl(userId).url.toString(), ... requestConfig })  
  return res.data
}